<template>
  <ModalBase class="modal_box is-init">
    <template v-slot:main>
      <div class="modal-error">
        <div class="modal-error__wrapper">
          <div class="modal-error__icon">
            <iconError/>
          </div>
          <div class="modal-error__title">{{ $t('error.title') }}</div>
          <div class="modal-error__desc">{{ message }}</div>
          <div class="modal-error__action">
            <Button @click="close" full>{{ $t('common.close') }}</Button>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/modals/ModalBase'
import iconError from '@/components/icons/iconError'
import Button from '@/components/buttons/Button'
import {mapActions, mapState} from 'vuex'
import * as types from '@/store/types'

export default {
  name: 'ModalLoader',
  data() {
    return {
      timeoutId: null
    }
  },
  components: {
    ModalBase,
    iconError,
    Button
  },
  computed: {
    ...mapState({
      apiKey: state => state.app.apiKey,
      message: state => state.gui.error.message,
      showMainPage: state => state.gui.error.showMainPage
    })
  },
  methods: {
    ...mapActions({
      guiErrorSet: types.GUI.error.set
    }),
    close() {
      if (this.showMainPage) {
        window.location.reload()
      }
      this.guiErrorSet({
        show: false,
        message: null,
        showMainPage: false
      })
    }
  },
  mounted() {
    // this.timeoutId = setTimeout(() => {
    // this.close()
    // }, 5000)
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId)
  }
}
</script>
